import { render, staticRenderFns } from "./Closed-Remark.vue?vue&type=template&id=0ed00b48"
import script from "./Closed-Remark.vue?vue&type=script&lang=js"
export * from "./Closed-Remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports